import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  const { title, author, description, imageUrl, link } = blog;

  const truncateText = (text, maxLength) => {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  };

  return (
    <li className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 ease-in-out">
      <Link to={link} className="block h-full">
        <div className="flex flex-col h-full">
          <div className="h-48 overflow-hidden">
            <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
          </div>
          <div className="p-6 flex flex-col flex-grow">
            <p className="text-gray-600 text-sm mb-2">{author}</p>
            <h5 className="text-xl font-bold mb-3 text-gray-800">{title}</h5>
            <p className="text-gray-700 mb-4 flex-grow">{truncateText(description, 100)}</p>
            <p className="font-semibold text-pink-600 hover:text-pink-700 transition-colors duration-200 mt-auto">
              Read More
            </p>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default BlogCard; 